module.exports = __webpack_public_path__ + "static/media/happy_icon.947c6975.svg";